import { Component, Input } from '@angular/core';
import { AlertDriver } from 'app/shared/models/alert-driver.model';

/**
 * Contributing drivers behind an anomaly, each with the share of the movement it explains.
 *
 * Shared rather than local to the tray because the same list appears in DEO's answers.
 *
 * @example
 * ```html
 * <gains-driver-list [drivers]="alert.drivers"></gains-driver-list>
 * ```
 */
@Component({
  selector: 'gains-driver-list',
  standalone: false,
  templateUrl: './gains-driver-list.component.html',
  styleUrl: './gains-driver-list.component.scss'
})
export class GainsDriverListComponent {
  /** The drivers to list, in the order the agent ranked them. */
  @Input() drivers: AlertDriver[] = [];

  /** Section label above the list. */
  @Input() heading = 'Contributing factors';

  /** Nothing renders without drivers — an empty box reads as missing data. */
  get hasDrivers(): boolean {
    return this.drivers?.length > 0;
  }

  protected trackByLabel(index: number, driver: AlertDriver): string {
    return driver.label;
  }
}
